/** Filter inputs that must keep focus/selection across innerHTML panel re-renders. */
export const TICKER_FILTER_INPUT_IDS = new Set([
  "wheelOptTicker",
  "wheelPutTicker",
  "wheelCallTicker",
  "tradierPutTicker",
  "tradierCallTicker",
  "wheelStockTicker",
  "wheelHistTicker",
  "wheelFocusInput",
  "sfe-watchlist-input",
  "sfe-mobile-ticker-input",
  "sfe-mobile-options3-ticker",
  "sfe-mobile-stocks-ticker",
  "sfe-mobile-puts1-ticker",
  "sfe-mobile-calls1-ticker",
  "sfeAgentsOptionsTicker",
  "sfeAgentsTxnTicker",
  "sfeAnalyticsTicker",
]);

export function isTickerFilterInput(el: Element | null): el is HTMLInputElement {
  return el instanceof HTMLInputElement && TICKER_FILTER_INPUT_IDS.has(el.id);
}

export interface PreservedInputFocus {
  id: string;
  selectionStart: number | null;
  selectionEnd: number | null;
}

export function capturePreservedInputFocus(): PreservedInputFocus | null {
  const active = document.activeElement;
  if (!isTickerFilterInput(active)) return null;
  return {
    id: active.id,
    selectionStart: active.selectionStart,
    selectionEnd: active.selectionEnd,
  };
}

export function restorePreservedInputFocus(captured: PreservedInputFocus | null): void {
  if (!captured) return;
  const el = document.getElementById(captured.id);
  if (!isTickerFilterInput(el)) return;
  el.focus({ preventScroll: true });
  if (
    captured.selectionStart != null &&
    captured.selectionEnd != null &&
    typeof el.setSelectionRange === "function"
  ) {
    try {
      el.setSelectionRange(captured.selectionStart, captured.selectionEnd);
    } catch {
      /* number/date inputs may reject selection ranges */
    }
  }
}

export function withPreservedInputFocus(rerender: () => void): void {
  const captured = capturePreservedInputFocus();
  rerender();
  restorePreservedInputFocus(captured);
}
